const MODEL_INFORMATION = {
    numWatersheds: '123',
    meanError: '-2.8',
    medianError: '-4.2',
    meanAbsoluteError: '13.9',
    watershedsWithin20Percent: '80.5',
    climateDriverYears: '1971-2000',
};

module.exports = {
    MODEL_INFORMATION,
};
